import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Button,
  Table,
  Form,
  Label,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { ToastContainer, toast } from "react-toastify"
import { useHistory } from "react-router-dom"
import ReactPaginate from "react-paginate"
import axios from "axios"
import { URLS } from "../../Url"
import { CSVLink } from "react-csv"
import jsPDF from "jspdf"
import "jspdf-autotable"

function Ventures() {
  const [Actin, setActin] = useState([])
  const [communities, setCommunities] = useState([])
  const [filters, setFilters] = useState({ community: "", categoryName: "" })
  const [categories, setcategories] = useState([])
  const [Searchs, setSearchs] = useState([])
  const [filter, setFilter] = useState(false)
  const [listPerPage] = useState(5)
  const [pageNumber, setPageNumber] = useState(0)

  const history = useHistory()
  const token = JSON.parse(localStorage.getItem("authUser"))?.token

  useEffect(() => {
    GetUsers()
    fetchCommunities()
    datass()
    GetAllCategories()
  }, [])

  const GetUsers = () => {
    axios
      .post(
        URLS.GetUserlist,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then(res => {
        setActin(res.data.activeusers)
        setPageNumber(0)
      })
  }

  // categories
  const fetchCommunities = () => {
    axios
      .post(
        "https://api.jaininternationalnetwork.com/v1/a2zsolutionsapi/admin/community/getall",
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then(res => {
        if (res.data.success) {
          const userCommunityObjects = res.data.usercommunities.map(
            (community, index) => ({
              _id: `user_${index}`,
              community: community,
            })
          )

          // comibing the communities and usercommunities
          const allCommunities = [
            ...(res.data.communities || []),
            ...userCommunityObjects,
          ]

          setCommunities(allCommunities)
        } else {
          toast(res.data.message)
        }
      })
  }
  const pagesVisited = pageNumber * listPerPage
  const lists = Actin.slice(pagesVisited, pagesVisited + listPerPage)
  const pageCount = Math.ceil(Actin.length / listPerPage)

  const changePage = ({ selected }) => {
    setPageNumber(selected)
  }

  const Actinid1 = data => {
    sessionStorage.setItem("UserId", data._id)
    history.push("/ViewUser")
  }

  const datass = () => {
    const location = sessionStorage.getItem("tost")
    if (location) {
      toast(location)
      sessionStorage.clear()
    } else {
      sessionStorage.clear()
    }
  }

  const Search = e => {
    let myUser = { ...Searchs }
    myUser[e.target.name] = e.target.value
    setSearchs(myUser)
    axios
      .post(
        URLS.GetUserSearch + `${e.target.value}`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setActin(res.data.activeusers)
      })
  }

  const handleChangeflt = e => {
    setFilters({
      ...filters,
      [e.target.name]: e.target.value,
    })
  }

  const getfilter = e => {
    e.preventDefault()
    GetOrderFiliter()
  }

  const GetOrderFiliter = () => {
    const bodyData = {
      community: filters.community,
      categoryName: filters.categoryName,
    }
    axios
      .post(URLS.GetUserlist, bodyData, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(res => {
        setActin(res.data.activeusers)
        hidefilter()
        setFilters({ community: "", categoryName: "" })
      })
  }

  // categories
  const GetAllCategories = () => {
    axios
      .post(
        "https://api.jaininternationalnetwork.com/v1/a2zsolutionsapi/admin/category/getallcategorys",
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then(res => {
        if (res.data.success) {
          setcategories(res.data.category)
        } else {
          toast(res.data.message)
        }
      })
  }

  const hidefilter = () => setFilter(false)

  const handleReset = () => {
    setSearchs({ name: "", email: "", phone: "" })
    setFilters({ community: "", categoryName: "" })
    setPageNumber(0)
    GetUsers()
  }

  // excel funtionality
  const headers2 = [
    { label: "S.No", key: "sno" },
    { label: "Name", key: "name" },
    { label: "phone", key: "phone" },
    { label: "Email", key: "email" },
    { label: "Community", key: "community" },
    { label: "Status", key: "status" },
  ]

  const csvData = Actin.map((elt, i) => ({
    sno: i + 1,
    name: elt.name,
    phone: elt.phone,
    email: elt.email,
    community: elt.community,
    status: elt.status,
  }))

  
  const exportPDF = () => {
    const unit = "pt"
    const size = "A2"
    const orientation = "portrait"
    const doc = new jsPDF(orientation, unit, size)
    doc.setFontSize(15)
    const headers123 = [
      [
        "S.No",
        "Name",
        "Phone",
        "Email",
        "Community",
        "Status",
      ],
    ]

    const data123 = Actin.map((elt, i) => [
      i + 1,
      elt.name,
      elt.phone,
      elt.email,
      elt.community,
      elt.status == true?"Active":"Inactive",
    ])

    let content = {
      startY: 50,
      head: headers123,
      body: data123,
    }
    console.log(content)
    doc.autoTable(content)
    doc.save("Users.pdf")
  }


  const csvReport = {
    filename: "Users.csv",
    headers: headers2,
    data: csvData,
  }


  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Home" breadcrumbItem="Users" />
          {filter && (
            <Card>
              <CardBody>
                <Form onSubmit={getfilter}>
                  <Row>
                    <Col lg="3">
                      <div className="mb-3">
                        <Label for="community-filter">
                          Community 
                        </Label>
                        <select
                          id="community-filter"
                          className="form-select"
                          value={filters.community}
                          name="community"
                          onChange={handleChangeflt}
                        >
                          <option value="">Select</option>
                          {communities.map((community, index) => (
                            <option key={index} value={community.community}>
                              {community.community}
                            </option>
                          ))}
                        </select>
                      </div>
                    </Col>
                    <Col lg="3">
                      <div className="mb-3">
                        <Label for="category-filter">Category</Label>
                        <select
                          id="category-filter"
                          className="form-select"
                          value={filters.categoryName}
                          name="categoryName"
                          onChange={handleChangeflt}
                        >
                          <option value="">Select</option>
                          {categories.map((category, index) => (
                            <option key={index} value={category.name}>
                              {category.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </Col>
                    <Col lg="3">
                      <div className="mt-4">
                        <Button type="submit" className="m-1" color="info">
                          <i className="fas fa-check-circle"></i> Search
                        </Button>
                        <Button
                          onClick={hidefilter}
                          className="m-1"
                          color="danger"
                        >
                          <i className="fas fa-times-circle"></i> Cancel
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Card>
          )}
          <Row>
            <Col>
              <Card>
                <CardBody>
                  <Row>
                    <Col>
                      <Button
                        className="m-1"
                        onClick={() => setFilter(!filter)}
                        color="info"
                      >
                        <i className="fas fa-filter"></i> Filter
                      </Button>
                      <Button
                        className="m-1"
                        onClick={handleReset}
                        color="info"
                      >
                        <i className="fas fa-sync-alt"></i> Reset
                      </Button>
                      <CSVLink {...csvReport}>
                        <button
                          className="btn btn-success me-2 m-1"
                          type="button"
                        >
                          <i className="fas fa-file-excel"></i> Excel
                        </button>
                      </CSVLink>
                      <Button
                        type="button"
                        className="btn btn-danger "
                        onClick={exportPDF}
                      >
                        <i className="fas fa-file-pdf"></i> Pdf
                      </Button>
                    </Col>
                    <Col>
                      <div style={{ float: "right" }}>
                        <Input
                          type="search"
                          name="search"
                          value={Searchs.search}
                          onChange={Search}
                          className="form-control"
                          placeholder="Search.."
                          autoComplete="off"
                        />
                      </div>
                    </Col>
                  </Row>
                  <div className="table-rep-plugin mt-4 table-responsive">
                    <Table hover className="table table-bordered mb-4">
                      <thead>
                        <tr className="text-center">
                          <th>SlNo</th>
                          <th>Name</th>
                          <th>Phone</th>
                          <th>Email</th>
                          <th>Community</th>
                          <th>Business Type</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {lists.map((data, key) => (
                          <tr key={key} className="text-center">
                            <td>{pageNumber * listPerPage + key + 1}</td>
                            <td>{data.name}</td>
                            <td>{data.phone}</td>
                            <td>{data.email}</td>
                            <td>{data.community}</td>
                            <td>{data.vendor ? "vendor" : "individual"}</td>
                            <td>
                              <span
                                className={`badge ${
                                  data.status ? "bg-success" : "bg-danger"
                                }`}
                              >
                                {data.status ? "Active" : "InActive"}
                              </span>
                            </td>
                            <td>
                              <Button
                                onClick={() => Actinid1(data)}
                                className="m-1 btn-sm"
                                color="info"
                              >
                                <div className="d-flex">
                                  <small>
                                    <i className="fas fa-eye m-1"></i> View
                                  </small>
                                </div>
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    <div
                      className="d-flex mt-3 mb-1"
                      style={{ float: "right" }}
                    >
                      <ReactPaginate
                        previousLabel={"Previous"}
                        nextLabel={"Next"}
                        pageCount={pageCount}
                        onPageChange={changePage}
                        containerClassName={"pagination"}
                        previousLinkClassName={"previousBttn"}
                        nextLinkClassName={"nextBttn"}
                        disabledClassName={"disabled"}
                        activeClassName={"active"}
                        total={lists.length}
                        forcePage={pageNumber}
                      />
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <ToastContainer />
        </div>
      </div>
    </React.Fragment>
  )
}

export default Ventures
